import React from "react";
import Modal from "components/BaseWidgets/modal";
import "./style.scss";
import { CloseIcon } from "assets/icons";

function NotificationModal({ open, onCancel, title = "Happy Day!", message }) {
  return (
    <Modal
      isOpen={open}
      onCancel={onCancel}
      width={671}
      footer={null}
      closable={true}
      closeIcon={<CloseIcon stroke="#FFFFFF" />}
      className="notification-modal"
      wrapClassName="notification-modal"
    >
      <h2 className="modal-heading">{title}</h2>
      <div className="notification-content flex flex-col items-center text-center">
        <p className="modal-text">
          {message ? (
            message
          ) : (
            <>
              Today, we celebrate and appreciate everyone who makes this day
              special. Wishing you all{" "}
              <span className="highlight">{title}</span>
            </>
          )}
        </p>
      </div>
    </Modal>
  );
}

export default NotificationModal;
